(async function() {
    /**
     * Set 'DISABLE' to true if you want to disable this feature
     */
    let DISABLE = false;
    if (DISABLE) {
        debug(`OOS check feature is disabled!`);
        return;
    }
    // QA
    let API_URL = "https://6o0jauv4ab.execute-api.us-west-2.amazonaws.com/qa/shopify";

    // PROD
    if (location.hostname.indexOf("mvstselect.com") > -1 || location.hostname.indexOf("shopifypreview.com") > -1) {
        debug(`Running in production env, so change API url to prod`);
        API_URL = "https://6o0jauv4ab.execute-api.us-west-2.amazonaws.com/prod/shopify-prod";
    }

    function translate(text) {
        const translations = {
            "sold out": "Sold out",
            "add to cart": "Add to cart",
            "pre order": "Pre-order",
        }

        const normalizedText = text.toLowerCase();
        debug(`translate: ${normalizedText} -> ${translations[normalizedText]}`);

        return translations[normalizedText] || text;
    }
    
    function timestamp() {
        let dt = new Date();
        return dt.getFullYear() + "-" +(dt.getMonth()+1) + "-" + dt.getDate() + "T" +dt.getHours()+":"+dt.getMinutes()+":"+dt.getSeconds()+"."+dt.getMilliseconds();
    }

    function debug(msg) {
        if (location.href.indexOf("mdebug=1") > -1 || document.cookie.indexOf("mdebug=1") > -1) {
            console.log(`[${timestamp()}] oos_check: ${msg}`);
        }
    }

    async function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function retry(func, maxRetry, taskName, waitMs) {
        let retry = maxRetry;

        if (!waitMs) {
            debug(`No waitMs, so use 1s as default`);
            waitMs = 1000;
        }

        let lastError = "";
        while (retry-- > 0) {
            try {
                return await func();
            } catch(err) {
                lastError = err + "";
                debug(`Error: Retry[${retry}], taskName[${taskName}], error[${err}]`);
            }

            await delay(waitMs);
            debug(`Waited ${waitMs}ms before retrying`);
        }

        let msg = `taskName[${taskName}] Retried [${maxRetry}] times. Last error [${lastError}]`;
        debug(msg);
        throw new Error(msg);
    }

    function getSelectedVariant() {
        const variantId = document.querySelector('buy-buttons button[type="submit"]')?.closest(`form.shopify-product-form`)?.querySelector(`input[name="id"]`)?.value;
        let variant = oosCheckData.variants.find(o => o.id == variantId);
        return variant;
    }

    function getRestockDate(inventories, variantId) {
        if (!inventories || inventories.length === 0 || !variantId) {
            debug(`No inventories or variantId, so return empty string`);
            return "";
        }

        const inventoriesHasRestockDate = inventories.filter(o => o.variantId+"" === variantId+"" && o.restockDate);
        if (inventoriesHasRestockDate.length === 0) {
            debug(`No restock date found for variantId[${variantId}]`);
            return "";
        }

        const date = inventoriesHasRestockDate[0].restockDate;

        // Validate the date format using Date object
        const year = parseInt(date.substring(0, 4));
        const month = parseInt(date.substring(4, 6)) - 1;
        const day = parseInt(date.substring(6, 8));

        const restockDate = new Date(year, month, day);
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 1); // Add one day to the current date

        if (restockDate < currentDate) {
            debug("Restock date is less than 1 day from now.");
            return "";
        }

        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return `${months[month]} ${day}`;
    }

    function updateUI(data) {
        let variant = getSelectedVariant();
        if (!variant) {
            debug(`No selected variant detected, so do nothing`);
            return;
        }

        let selectedOptionText = variant.title;
        let variantId = variant.id;
        
        let isAvailable = !document.querySelector(`buy-buttons button[type="submit"]`).hasAttribute("disabled");

        if (isAvailable) {
            hideRestockSection();
            debug(`The product is available. selectedOptionText: ${selectedOptionText}, variantId: ${variantId}`);
        } else {
            const restockDate = getRestockDate(data.inventories, variantId);
            showRestockSection(restockDate);
            debug(`The product is unavailable. selectedOptionText: ${selectedOptionText}, variantId: ${variantId}`);
        }
    }

    function isValidEmail(email) {
        if (typeof email !== 'string') {
            return false;
        }
    
        const normalizedEmail = email.trim();
        if (!normalizedEmail) {
            return false;
        }
    
        const emailRegex =
            /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@(?:(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)\.)+[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i;
    
        return emailRegex.test(normalizedEmail);
    }
    

    function injectRestockElements(targetEle) {
        const restockHtml = `
            <div class="mvst-restock-container" style="display: none; row-gap: 1rem;margin-top: 1rem;">
                <p class="mvst-restock-date-msg" style="display: none;">Estimated restock date: <b class="mvst-restock-date"></b>.</p>
                <p class="mvst-restock-msg">Enter your email and shipping country to get notified once the item is restocked. If you would like to place a pre-order now, please contact us.</p>
                <input id="mvst-restock-email" placeholder="Email" class="input" type="email" required>
                <select id="mvst-restock-country" class="select" >
                  <!-- Special or placeholder -->
                  <option value="--">Select Country</option>
                  
                  <!-- Main list (ISO 3166-1 alpha-2 codes) -->
                  <option value="AF">Afghanistan</option>
                  <option value="AX">Åland Islands</option>
                  <option value="AL">Albania</option>
                  <option value="DZ">Algeria</option>
                  <option value="AD">Andorra</option>
                  <option value="AO">Angola</option>
                  <option value="AI">Anguilla</option>
                  <option value="AG">Antigua &amp; Barbuda</option>
                  <option value="AR">Argentina</option>
                  <option value="AM">Armenia</option>
                  <option value="AW">Aruba</option>
                  <!-- Ascension Island is often given an unofficial code "AC" -->
                  <option value="AC">Ascension Island</option>
                  <option value="AU">Australia</option>
                  <option value="AT">Austria</option>
                  <option value="AZ">Azerbaijan</option>
                  <option value="BS">Bahamas</option>
                  <option value="BH">Bahrain</option>
                  <option value="BD">Bangladesh</option>
                  <option value="BB">Barbados</option>
                  <option value="BY">Belarus</option>
                  <option value="BE">Belgium</option>
                  <option value="BZ">Belize</option>
                  <option value="BJ">Benin</option>
                  <option value="BM">Bermuda</option>
                  <option value="BT">Bhutan</option>
                  <option value="BO">Bolivia</option>
                  <option value="BA">Bosnia &amp; Herzegovina</option>
                  <option value="BW">Botswana</option>
                  <option value="BR">Brazil</option>
                  <option value="IO">British Indian Ocean Territory</option>
                  <option value="VG">British Virgin Islands</option>
                  <option value="BN">Brunei</option>
                  <option value="BG">Bulgaria</option>
                  <option value="BF">Burkina Faso</option>
                  <option value="BI">Burundi</option>
                  <option value="KH">Cambodia</option>
                  <option value="CM">Cameroon</option>
                  <option value="CA">Canada</option>
                  <option value="CV">Cape Verde</option>
                  <option value="BQ">Caribbean Netherlands</option>
                  <option value="KY">Cayman Islands</option>
                  <option value="CF">Central African Republic</option>
                  <option value="TD">Chad</option>
                  <option value="CL">Chile</option>
                  <option value="CN">China</option>
                  <option value="CX">Christmas Island</option>
                  <option value="CC">Cocos (Keeling) Islands</option>
                  <option value="CO">Colombia</option>
                  <option value="KM">Comoros</option>
                  <option value="CG">Congo - Brazzaville</option>
                  <option value="CD">Congo - Kinshasa</option>
                  <option value="CK">Cook Islands</option>
                  <option value="CR">Costa Rica</option>
                  <option value="HR">Croatia</option>
                  <option value="CW">Curaçao</option>
                  <option value="CY">Cyprus</option>
                  <option value="CZ">Czechia</option>
                  <option value="CI">Côte d’Ivoire</option>
                  <option value="DK">Denmark</option>
                  <option value="DJ">Djibouti</option>
                  <option value="DM">Dominica</option>
                  <option value="DO">Dominican Republic</option>
                  <option value="EC">Ecuador</option>
                  <option value="EG">Egypt</option>
                  <option value="SV">El Salvador</option>
                  <option value="GQ">Equatorial Guinea</option>
                  <option value="ER">Eritrea</option>
                  <option value="EE">Estonia</option>
                  <option value="SZ">Eswatini</option>
                  <option value="ET">Ethiopia</option>
                  <option value="FK">Falkland Islands</option>
                  <option value="FO">Faroe Islands</option>
                  <option value="FJ">Fiji</option>
                  <option value="FI">Finland</option>
                  <option value="FR">France</option>
                  <option value="GF">French Guiana</option>
                  <option value="PF">French Polynesia</option>
                  <option value="TF">French Southern Territories</option>
                  <option value="GA">Gabon</option>
                  <option value="GM">Gambia</option>
                  <option value="GE">Georgia</option>
                  <option value="DE">Germany</option>
                  <option value="GH">Ghana</option>
                  <option value="GI">Gibraltar</option>
                  <option value="GR">Greece</option>
                  <option value="GL">Greenland</option>
                  <option value="GD">Grenada</option>
                  <option value="GP">Guadeloupe</option>
                  <option value="GT">Guatemala</option>
                  <option value="GG">Guernsey</option>
                  <option value="GN">Guinea</option>
                  <option value="GW">Guinea-Bissau</option>
                  <option value="GY">Guyana</option>
                  <option value="HT">Haiti</option>
                  <option value="HN">Honduras</option>
                  <option value="HK">Hong Kong SAR</option>
                  <option value="HU">Hungary</option>
                  <option value="IS">Iceland</option>
                  <option value="IN">India</option>
                  <option value="ID">Indonesia</option>
                  <option value="IQ">Iraq</option>
                  <option value="IE">Ireland</option>
                  <option value="IM">Isle of Man</option>
                  <option value="IL">Israel</option>
                  <option value="IT">Italy</option>
                  <option value="JM">Jamaica</option>
                  <option value="JP">Japan</option>
                  <option value="JE">Jersey</option>
                  <option value="JO">Jordan</option>
                  <option value="KZ">Kazakhstan</option>
                  <option value="KE">Kenya</option>
                  <option value="KI">Kiribati</option>
                  <!-- 'XK' is a commonly used placeholder for Kosovo, not officially ISO-assigned -->
                  <option value="XK">Kosovo</option>
                  <option value="KW">Kuwait</option>
                  <option value="KG">Kyrgyzstan</option>
                  <option value="LA">Laos</option>
                  <option value="LV">Latvia</option>
                  <option value="LB">Lebanon</option>
                  <option value="LS">Lesotho</option>
                  <option value="LR">Liberia</option>
                  <option value="LY">Libya</option>
                  <option value="LI">Liechtenstein</option>
                  <option value="LT">Lithuania</option>
                  <option value="LU">Luxembourg</option>
                  <option value="MO">Macao SAR</option>
                  <option value="MG">Madagascar</option>
                  <option value="MW">Malawi</option>
                  <option value="MY">Malaysia</option>
                  <option value="MV">Maldives</option>
                  <option value="ML">Mali</option>
                  <option value="MT">Malta</option>
                  <option value="MQ">Martinique</option>
                  <option value="MR">Mauritania</option>
                  <option value="MU">Mauritius</option>
                  <option value="YT">Mayotte</option>
                  <option value="MX">Mexico</option>
                  <option value="MD">Moldova</option>
                  <option value="MC">Monaco</option>
                  <option value="MN">Mongolia</option>
                  <option value="ME">Montenegro</option>
                  <option value="MS">Montserrat</option>
                  <option value="MA">Morocco</option>
                  <option value="MZ">Mozambique</option>
                  <option value="MM">Myanmar (Burma)</option>
                  <option value="NA">Namibia</option>
                  <option value="NR">Nauru</option>
                  <option value="NP">Nepal</option>
                  <option value="NL">Netherlands</option>
                  <option value="NC">New Caledonia</option>
                  <option value="NZ">New Zealand</option>
                  <option value="NI">Nicaragua</option>
                  <option value="NE">Niger</option>
                  <option value="NG">Nigeria</option>
                  <option value="NU">Niue</option>
                  <option value="NF">Norfolk Island</option>
                  <option value="MK">North Macedonia</option>
                  <option value="NO">Norway</option>
                  <option value="OM">Oman</option>
                  <option value="PK">Pakistan</option>
                  <option value="PS">Palestinian Territories</option>
                  <option value="PA">Panama</option>
                  <option value="PG">Papua New Guinea</option>
                  <option value="PY">Paraguay</option>
                  <option value="PE">Peru</option>
                  <option value="PH">Philippines</option>
                  <option value="PN">Pitcairn Islands</option>
                  <option value="PL">Poland</option>
                  <option value="PT">Portugal</option>
                  <option value="QA">Qatar</option>
                  <option value="RE">Réunion</option>
                  <option value="RO">Romania</option>
                  <option value="RU">Russia</option>
                  <option value="RW">Rwanda</option>
                  <option value="WS">Samoa</option>
                  <option value="SM">San Marino</option>
                  <option value="ST">São Tomé &amp; Príncipe</option>
                  <option value="SA">Saudi Arabia</option>
                  <option value="SN">Senegal</option>
                  <option value="RS">Serbia</option>
                  <option value="SC">Seychelles</option>
                  <option value="SL">Sierra Leone</option>
                  <option value="SG">Singapore</option>
                  <option value="SX">Sint Maarten</option>
                  <option value="SK">Slovakia</option>
                  <option value="SI">Slovenia</option>
                  <option value="SB">Solomon Islands</option>
                  <option value="SO">Somalia</option>
                  <option value="ZA">South Africa</option>
                  <option value="GS">South Georgia &amp; South Sandwich Islands</option>
                  <option value="KR">South Korea</option>
                  <option value="SS">South Sudan</option>
                  <option value="ES">Spain</option>
                  <option value="LK">Sri Lanka</option>
                  <option value="BL">St. Barthélemy</option>
                  <option value="SH">St. Helena</option>
                  <option value="KN">St. Kitts &amp; Nevis</option>
                  <option value="LC">St. Lucia</option>
                  <option value="MF">St. Martin</option>
                  <option value="PM">St. Pierre &amp; Miquelon</option>
                  <option value="VC">St. Vincent &amp; Grenadines</option>
                  <option value="SD">Sudan</option>
                  <option value="SR">Suriname</option>
                  <option value="SJ">Svalbard &amp; Jan Mayen</option>
                  <option value="SE">Sweden</option>
                  <option value="CH">Switzerland</option>
                  <option value="TW">Taiwan</option>
                  <option value="TJ">Tajikistan</option>
                  <option value="TZ">Tanzania</option>
                  <option value="TH">Thailand</option>
                  <option value="TL">Timor-Leste</option>
                  <option value="TG">Togo</option>
                  <option value="TK">Tokelau</option>
                  <option value="TO">Tonga</option>
                  <option value="TT">Trinidad &amp; Tobago</option>
                  <!-- Tristan da Cunha often lumps under St. Helena (SH). "TA" is an unofficial code. -->
                  <option value="TA">Tristan da Cunha</option>
                  <option value="TN">Tunisia</option>
                  <option value="TR">Türkiye</option>
                  <option value="TM">Turkmenistan</option>
                  <option value="TC">Turks &amp; Caicos Islands</option>
                  <option value="TV">Tuvalu</option>
                  <option value="UM">U.S. Outlying Islands</option>
                  <option value="UG">Uganda</option>
                  <option value="UA">Ukraine</option>
                  <option value="AE">United Arab Emirates</option>
                  <option value="GB">United Kingdom</option>
                  <option value="US">United States</option>
                  <option value="UY">Uruguay</option>
                  <option value="UZ">Uzbekistan</option>
                  <option value="VU">Vanuatu</option>
                  <option value="VA">Vatican City</option>
                  <option value="VE">Venezuela</option>
                  <option value="VN">Vietnam</option>
                  <option value="WF">Wallis &amp; Futuna</option>
                  <option value="EH">Western Sahara</option>
                  <option value="YE">Yemen</option>
                  <option value="ZM">Zambia</option>
                  <option value="ZW">Zimbabwe</option>
                </select>
                <p id="mvst-restock-error" class="text-error"></p>
                <a id="mvst-restock-submit" class="button w-full">Subscribe</a>
            </div>
        `;

        // Append this snippet at the end of the target element
        targetEle.insertAdjacentHTML("beforeend", restockHtml);

        // Add event listener to the button
        let subscribeButton = targetEle.querySelector(`#mvst-restock-submit`);
        subscribeButton.addEventListener("click", async function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            if (subscribeButton.getAttribute("disabled")) {
                debug(`The subscribe button is disabled, so do nothing`);
                return
            }

            let email = targetEle.querySelector(`#mvst-restock-email`).value;
            let country = targetEle.querySelector(`#mvst-restock-country`).value;
            let errorEle = targetEle.querySelector(`#mvst-restock-error`);
            errorEle.innerText = "";
            subscribeButton.setAttribute("disabled", "disabled");

            if (!email || !isValidEmail(email)) {
                errorEle.innerText = "Email is invalid";
                setTimeout(()=>{errorEle.innerText = ""}, 2000);
                subscribeButton.removeAttribute("disabled");
                return;
            }

            if (!country || country === "--") {
                errorEle.innerText = "Country can not be empty";
                setTimeout(()=>{errorEle.innerText = ""}, 2000);
                subscribeButton.removeAttribute("disabled");
                return;
            }

            let selectedVariant = getSelectedVariant();
            if (!selectedVariant) {
                debug(`No selected variant detected, so can not subscribe restock notification`);
                subscribeButton.removeAttribute("disabled");
                return;
            }

            const request = {
                "productId": oosCheckData.product.id,
                "productTitle": oosCheckData.productTitle,
                "variantId": selectedVariant.id,
                "variantTitle": selectedVariant.title,
                "email": email,
                "country": country
            }

            subscribeButton.innerText = "Processing...";
            subscribeButton.setAttribute("disabled", "disabled");
            let apiUrl = `${API_URL}/restock-subscribe`;
            await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(request)
            });
            debug(`Subscribed restock notification for email[${email}] and country[${country}]`);
            subscribeButton.innerText = "Subscribed!";
        });
    }

    function showRestockSection(restockDate) {
        // show restock subscription
        const restockContainer = document.querySelector(`.mvst-restock-container`);
        restockContainer.style.display = 'grid';

        // show restock date msg
        let msgEle = document.querySelector(`p.mvst-restock-date-msg`);
        let dateEle = document.querySelector(`p.mvst-restock-date-msg .mvst-restock-date`);
        if (restockDate) {
            msgEle.style.display = 'block';
            dateEle.innerText = restockDate;
        } else {
            msgEle.style.display = 'none';
            dateEle.innerText = "";
        }
    }

    function hideRestockSection() {
        const restockContainer = document.querySelector(`.mvst-restock-container`);
        restockContainer.style.display = 'none';
    }
    
    async function getInventoryLevelData(oosCheckData) {
        let customerCountryCode = oosCheckData.customerCountryCode;

        let productTitle = oosCheckData.productTitle;
        let variantIds = oosCheckData.variants.map(o => o.id);

        let apiUrl = `${API_URL}/oos-check?country=${customerCountryCode}&variant_ids=${encodeURIComponent(variantIds.join(','))}&product_title=${encodeURIComponent(productTitle)}&url=${encodeURIComponent(location.href)}&cb=${Date.now()}`;

        let response = await retry(async () => {
            return await fetch(apiUrl);
        }, 5, "Fetch data remotely");

        return response.json();
    }

    // 
    async function start() {
        if (!location.pathname.match(/\/products\//i)) {
            debug(`Not under product page, so do nothing`);
            return;
        }

        let productTitle = oosCheckData.productTitle;
        if (productTitle.toLowerCase().indexOf("trek") > -1) {
            debug(`Trek product do not need to show restock info`);
            return;
        }

        let addCartButton = document.querySelector(`buy-buttons button[type="submit"]`);
        if (!addCartButton) {
            debug(`No add cart button found, so do nothing`);
            return;
        }

        debug(`oosCheckData=${JSON.stringify(oosCheckData)}`);

        // key: variantId, value: count
        let inventoryData = await getInventoryLevelData(oosCheckData);
        debug(`Inventory data=${JSON.stringify(inventoryData)}`);

        // create restock subscription container
        const buyButtonsEle = document.querySelector(`div[data-block-type="buy-buttons"]`);
        injectRestockElements(buyButtonsEle);

        // update UI immediately
        updateUI(inventoryData);

        // Start observing
        // v11: the whole <buy-buttons> element is swapped on variant change (partial rerender in theme.js),
        // which detaches an observer bound to the button node itself — observe the surviving block container
        // with subtree instead, and ignore mutations coming from our own restock UI to avoid a feedback loop
        new MutationObserver(function(mutations) {
            const hasExternalMutation = mutations.some(function(mutation) {
                const ele = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
                return !(ele && ele.closest && ele.closest('.mvst-restock-container'));
            });
            if (hasExternalMutation) {
                debug(`Buy buttons block changed`);
                updateUI(inventoryData);
            }
        }).observe(buyButtonsEle, {
            childList: true,
            characterData: true,
            subtree: true
        });

        // setInterval(function () {
        //     updateUI(inventoryData);
        // }, 500);
        // debug(`Started available UI update interval`);
    }

    debug(`OOS check script started`);
    await start();
})();
